import axios from "axios";
import * as types from '../constants/ActionTypes';
import { toast } from 'react-toastify';
// import {clearCartInfo} from './cart';

// Url's
// const getOrderURL = `${process.env.REACT_APP_API_URL}api/csa-app/get-endless-aisle-order`;
// const saveOrderURL = `${process.env.REACT_APP_API_URL}mobileshop/csacart/save-endless-aisle-order-pay-now`;
// const getStoreCreditURL  = `${process.env.REACT_APP_API_URL}api/csa-app/store-credit-settlement`;
// const segregateCartURL = `${process.env.REACT_APP_API_URL}api/csa-app/segregate-cart`;

const getOrderURL = `${process.env.REACT_APP_API_URL}mobileshop/csacart/get-endless-aisle-order`;
const saveOrderURL = `${process.env.REACT_APP_API_URL}mobileshop/csacart/save-endless-aisle-order-pay-now`;
const getStoreCreditURL  = `${process.env.REACT_APP_API_URL}mobileshop/csacart/store-credit-settlement`;
const segregateCartURL = `${process.env.REACT_APP_API_URL}mobileshop/csacart/segregate-cart`;

// Actions
const getOrderSuccess = data => ({
  type: types.GET_ORDER_SUCCESS,
  data
});

const getOrderRequested = () => ({
  type: types.GET_ORDER_REQUEST
});

const getOrderFailure = error => ({
  type: types.GET_ORDER_FAILURE,
  error
});


// store credit

const getStoreCreditSuccess = data => ({
  type: types.GET_STORE_CREDIT_SUCCESS,
  data
});

const getStoreCreditRequested = () => ({
  type: types.GET_STORE_CREDIT_REQUEST
});

const getStoreCreditFailure = error => ({
  type: types.GET_STORE_CREDIT_FAILURE,
  error
});


// success

const saveOrderSuccess = data => ({
  type: types.SAVE_ORDER_SUCCESS,
  data
});

const saveOrderRequested = () => ({
  type: types.SAVE_ORDER_REQUEST
});

const saveOrderFailure = error => ({
  type: types.SAVE_ORDER_FAILURE,
  error
});


// Segregate Cart

const segregateCartRequest = () => ({
  type: types.SEGREGATE_CART_REQUEST
})

const segregateCartSuccess = (data) => ({
  type: types.SEGREGATE_CART_SUCCESS,
  data
})
const removeProfile = ()=>({
  type:types.CART_PROFILE_UPDATE,

})

const segregateCartFailure = (error) => ({
  type: types.SEGREGATE_CART_FAILURE,
  error
})



// API
export const getOrderInfo = (options) => {
  //
  return dispatch => {
    dispatch(getOrderRequested());
    axios.get(getOrderURL, {
      params: {
        connection_id: options.connection_id,
        web_session_trans_id: options.web_session_trans_id,
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(getOrderSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          toast.error(`Failed - ${res.data.status.message}`);
          dispatch(getOrderFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};


export const saveOrderInfo = (options) => {
 
  return dispatch => {

    dispatch(getStoreCreditRequested());
    axios.post(getStoreCreditURL, 
      {
        connection_id: options[0].connection_id,
        web_session_trans_id: options[0].web_session_trans_id,
        consumer_mobile_no: options[0].consumer_mobile_no,
        order_value: options[0].order_value,
        query_action: "SAVE",
      }, {
      headers: {
        'Accept': 'application/json',
          'Content-Type': 'application/json'
        //'Content-Type': 'application/json; charset=UTF-8'
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(getStoreCreditSuccess(res.data.results));
          dispatch(saveOrderRequested());
          console.log(options)

          axios.post(saveOrderURL, options, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
              //'Content-Type': 'application/json; charset=UTF-8'
            },
          })
            .then(res => {
              if (res.data.ack === "Success") {
                dispatch(saveOrderSuccess(res.data));
              } else if (res.data.ack === "Failure") {
                toast.error(`Failed - ${res.data.status.message}`);
                dispatch(saveOrderFailure(res.data.status));
              }
            })
            .catch(err => {
              throw err;
              // dispatch(addTodoFailure(err.message));
            });

          
        } else if (res.data.ack === "Failure") {
          toast.error(`Failed - ${res.data.status.message}`);
          dispatch(getStoreCreditFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const clearOrderInfo = (options) => {
  //
  return dispatch => {
          dispatch(saveOrderSuccess({status: null}));
  };
};


//store credit
export const getStoreCreditInfo = (options) => {
  //
  return dispatch => {
    dispatch(getStoreCreditRequested());
    // axios.post(getStoreCreditURL, {
    //   params: {
    //     connection_id: options.connection_id,
    //     web_session_trans_id: options.web_session_trans_id,
    //     consumer_mobile_no: options.consumer_mobile_no,
    //     order_value: options.order_value,
    //     query_action: options.query_action,
    //     tender_details: options.tender_details 
    //   },
    // })
    axios.post(getStoreCreditURL, options, {
      headers: {
        'Accept': 'application/json',
          'Content-Type': 'application/json'
        //'Content-Type': 'application/json; charset=UTF-8'
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(getStoreCreditSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          toast.error(`Failed - ${res.data.status.message}`);
          dispatch(getStoreCreditFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};


 export const segregateCart = (options,loc = null) => {
 
 
        
  
  return async dispatch => {
    try {
      dispatch(segregateCartRequest());
     
    const response = await axios.post(segregateCartURL, options, {
      headers: {
        'Accept': 'application/json',
          'Content-Type': 'application/json'
        //'Content-Type': 'application/json; charset=UTF-8'
      },
    })
    .then(res=>res.data);
    console.log(response.ack)
    if (response.ack === "Success") {
      if(loc !== null) { dispatch(removeProfile())} else {
      dispatch(segregateCartSuccess(response.results)) } 
      return "success"
    
   
    } else if (response.ack === "Failure") {
      toast.error(`Failed - ${response.status.message}`);
      dispatch(segregateCartFailure(response.status));
      return "failed"
  
    } 
      
  }
    catch(err) {
      dispatch(segregateCartFailure(err))
      return 'failed'
    }
    return 'done';
  }
}